import { createFileRoute } from '@tanstack/react-router';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/notificacao')({
    beforeLoad: () =>
        validateRoute({
            fintech: true,
        }),
});
